import {EyebrowBanner as PrimerEyebrowBanner, Image, useTheme} from '@primer/react-brand/esm'

import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import type {ThemedVisual} from '../../../Index.types'

import Styles from './EyebrowBanner.module.css'

export interface EyebrowBannerProps {
  image: ThemedVisual
  text: string
  url: string
}

export const defaultProps: Partial<EyebrowBannerProps> = {}

export const EyebrowBanner = (props: EyebrowBannerProps) => {
  const initializedProps: EyebrowBannerProps = {...defaultProps, ...props}
  const {image, text, url} = initializedProps
  const {colorMode} = useTheme()
  const imageUrl = colorMode === 'dark' ? image.url.dark || image.url.light : image.url.light

  return (
    <PrimerEyebrowBanner
      href={url}
      className={Styles['EyebrowBanner']}
      {...getAnalyticsEvent({action: text, tag: 'a', context: 'eyebrow', location: 'intro'})}
    >
      <PrimerEyebrowBanner.Visual>
        <Image src={imageUrl} alt={image.alt} className={Styles['EyebrowBanner__image']} />
      </PrimerEyebrowBanner.Visual>
      <PrimerEyebrowBanner.Heading className={Styles['EyebrowBanner__text']}>{text}</PrimerEyebrowBanner.Heading>
    </PrimerEyebrowBanner>
  )
}
